// Import packages
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { history } from "../configs/history";

// Import assets
import '../assets/styles/layout.scss'

// Import components
import Header from "../components/Header";
import Footer from "../components/Footer";

// Import utils
import { getPropsFromState } from "../redux/mapStateToProps";
import {
    GetLanguages,
    GetStaticTexts,
    GetAbout,
    GetMainSlider,
    GetContact,
    GetCurrency,
    GetBadges,
    GetAboutSlider, GetPartners, GetAreas, GetWorks, GetSettings, GetServices
} from "../redux/actions";
import MetaTags from "../components/MetaTags";
// import LeftBlock from "../components/LeftBlock";
import {Call, CallIcon, FilterClose, Mobil_icon, SoundOfIcon, SoundOnIcon} from "../assets/images";
import CallModel from "../components/modal/callModel/CallModel";
import {BUILDING_TYPE, MAX_AREA, MAX_PRICE, MIN_AREA, MIN_PRICE} from "../constants/acceptedConsts";
import ComingSoon from "./comingSoon/ComingSoon";
import HomeFilterBlock from "../components/HomeFilterBlock";
// import HousesFilter from "./housesFilter/HousesFilter";

function Layout (props) {
    const filtersInitialValues = {
        buildingSlug: null,
        floors: undefined,
        roomsCount: [],
        minArea: MIN_AREA,
        maxArea: MAX_AREA,
        minPrice: MIN_PRICE,
        maxPrice: MAX_PRICE,
        types:BUILDING_TYPE.Apartments,
        statuses: [],
        sort: 'price',
    }
    const [filters, setFilters] = useState(filtersInitialValues)
    const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
    const [soundOn, setSoundOn] = useState(false)
    const [callModelOpen,setCallModelOpen] = useState(false)

    useEffect(() => {
        props.GetLanguages()
        props.GetStaticTexts()
        props.GetBadges()
        props.GetPartners()
        props.GetWorks()
        props.GetSettings()
        props.GetServices()
        props.GetMainSlider().then(() => {
            props.GetAbout()
            props.GetAboutSlider()
            props.GetContact()
        })
    }, [ props.selectedLanguage?.id]);


    useEffect(() => {
        props.GetAreas()
        props.GetCurrency()
    }, []);


    const toggleMobileMenu = () => {
        setMobileMenuIsOpen(!mobileMenuIsOpen)
    };

    const toggleCallBtn = () => {
        setCallModelOpen(!callModelOpen)
    };

    const toggleSoundOn =(e)=> {
        let video = document.querySelector('video')
            e.preventDefault();
            video.muted = !video.muted;
            setSoundOn(!soundOn)
    }

    const { children ,staticTexts,contact} = props;
    const phone = contact?.phoneNumber?.replace(/\D/g,'').substring(0,12)
    return <div className={`LayoutWrapper ${mobileMenuIsOpen ? "mobileMenuOpen" : ""}`}>
         <MetaTags/>
         <Header mobileMenuIsOpen={mobileMenuIsOpen}
                 toggleMobileMenu={toggleMobileMenu}/>
        {
            <a className={'callUp'} href={`tel:+${phone}`}>
                <CallIcon/>
            </a>
        }
         {/*<CallModel  toggleCallBtn={toggleCallBtn}*/}
         {/*            callModelOpen={callModelOpen}/>*/}
         {/*{*/}
         {/*    window.innerWidth < 1001 ?*/}
         {/*        <div className={`menu-dropdown ${block ? "open" : ""}`}>*/}
         {/*            <span className={'close-icon'}  onClick={toggleMobileFilter}><FilterClose/></span>*/}
         {/*            <LeftBlock toggleMobileFilter={toggleMobileFilter}*/}
         {/*                       filtersInitialValues={filtersInitialValues}*/}
         {/*                       setFilters={setFilters}*/}
         {/*                       filters={filters} />*/}
         {/*        </div> :*/}
         {/*        <div className={'left-block-wrapper'}>*/}
         {/*            <LeftBlock  filtersInitialValues={filtersInitialValues}*/}
         {/*                        setFilters={setFilters}*/}
         {/*                        filters={filters}/>*/}
         {/*        </div>*/}
         {/*}*/}

         <div className={`MainContent`}>
             {children}
         </div>
         {/*<button className='callBtn' onClick={toggleCallBtn}>*/}
         {/*    <Call title=''/>*/}
         {/*</button>*/}
         <Footer/>

          {/*<div className={'layoutDisable'}>*/}
          {/*       <HomeFilterBlock  filtersInitialValues={filtersInitialValues}*/}
          {/*                      setFilters={setFilters}*/}
          {/*                      filtersList={filters}/>*/}
          {/*   </div>*/}
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'languages',
        'selectedLanguage',
        'staticTexts',
        'contact',
    ])
};

const mapDispatchToProps = {
    GetLanguages,
    GetStaticTexts,
    GetAbout,
    GetMainSlider,
    GetContact,
    GetCurrency,
    GetBadges,
    GetAboutSlider,
    GetPartners,
    GetWorks,
    GetAreas,
    GetSettings,
    GetServices
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
